import { render, staticRenderFns } from "./czclCov.vue?vue&type=template&id=56f52449&scoped=true"
import script from "./czclCov.vue?vue&type=script&lang=js"
export * from "./czclCov.vue?vue&type=script&lang=js"
import style0 from "./czclCov.vue?vue&type=style&index=0&id=56f52449&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f52449",
  null
  
)

export default component.exports